import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { getBrowserLang } from '@ngneat/transloco';

@Component({
  selector: 'angular-community-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent {

  constructor(
    private titleService: Title
  ) {
    this.titleService.setTitle('Angular Community Meetup | Home');
  }

  get cfpByLanguage(): string {
    switch (getBrowserLang()) {
      case 'es':
        return 'https://bit.ly/3DxuLWY'
      default:
        return 'https://forms.gle/1o2vwA2hHDnBoEAX6';
    }
  }

}
